import { Css, Icon, Palette } from "@homebound/beam";

export type DotIndicatorProps = {
  label: string;
  bgColor: string;
  dotColor: Palette;
  textColor?: string;
};

export function DotIndicator({ label, bgColor, dotColor, textColor = dotColor }: DotIndicatorProps) {
  return (
    <div css={Css.dif.aic.w75.bgColor(bgColor).p("10px").borderRadius("4px").color("#B42318").$}>
      <Icon icon="circle" inc={1} color={dotColor} />
      <span css={Css.ml1.color(textColor).$}>{label}</span>
    </div>
  );
}
